import { storage } from "../firebase/config";
import axios from "axios";
import { routes } from "../constants/routes";
import { setLoadingState, setResponse } from "../slices/image";
import { getTensor, modelPredict } from "../assets/predictor/predictor.js";
import {
  createImage,
  getCroppedImgDataURL,
} from "../components/imageCropper/CropImage";
import { ref, uploadBytes } from "firebase/storage";
import { Buffer } from "buffer";
import { CLASSES } from "../constants/variables";

export const getCroppedImage = async (image, croppedAreaPixels) => {
  try {
    const rawCroppedDataURL = await getCroppedImgDataURL(
      image.URL,
      croppedAreaPixels,
    );
    // Wait for the cropped image to decode: Safari (and every iOS browser)
    // decodes asynchronously, and drawing it early gives the model a blank image
    return await createImage(rawCroppedDataURL);
  } catch (e) {
    console.error(e);
  }
};

export const handleSubmitImage = async (
  event,
  ogImage,
  cropOn,
  model,
  croppedAreaPixels,
  dispatch,
) => {
  event.preventDefault();
  // console.log("hyellooo");
  let image;
  let file;
  let dataURL;
  dispatch(setLoadingState(true));
  // I don't know why this is necessary, but it is
  await new Promise((resolve) => setTimeout(resolve, 1));

  if (cropOn && croppedAreaPixels) {
    const croppedImageData = await getCroppedImage(ogImage, croppedAreaPixels);
    image = croppedImageData || ogImage.imageData;
  } else {
    image = ogImage.imageData;
    file = ogImage.file;
    dataURL = ogImage.URL;
  }

  await modelPredict(image, model, dispatch)
    .then((response) => {
      dispatch(setResponse(response));
    })
    .catch((error) => {
      dispatch(setLoadingState(false));
      console.error(error);
    });
  // try {
  //   const response = await modelPredict(image, model, dispatch);

  //   dispatch(setResponse(response));
  // } catch (error) {
  //   dispatch(setLoadingState(false));
  //   console.error(error);
  // }
  dispatch(setLoadingState(false));
};

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB
const MAX_DIMENSION = 1920; // max width or height in pixels

const getDatePrefix = () => {
  const now = new Date();
  return now.toISOString().slice(0, 19).replace(/[:T]/g, "-");
};

const compressImage = (file, maxDimension, maxSize) => {
  return new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      let { width, height } = img;

      // Scale down if either dimension exceeds the max
      if (width > maxDimension || height > maxDimension) {
        const scale = Math.min(maxDimension / width, maxDimension / height);
        width = Math.round(width * scale);
        height = Math.round(height * scale);
      }

      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, width, height);

      // Try progressively lower quality until under maxSize
      let quality = 0.9;
      const tryCompress = () => {
        canvas.toBlob(
          (blob) => {
            if (blob.size > maxSize && quality > 0.3) {
              quality -= 0.1;
              tryCompress();
            } else {
              resolve(blob);
            }
          },
          "image/jpeg",
          quality,
        );
      };
      tryCompress();
    };
    img.src = URL.createObjectURL(file);
  });
};

export const uploadToFirebase = async (file) => {
  const datePrefix = getDatePrefix();
  const baseName = file.name.replace(/\.[^/.]+$/, ""); // strip extension
  let uploadFile = file;
  let ext = file.name.split(".").pop();

  // Downsample if file is too large
  if (file.size > MAX_FILE_SIZE) {
    console.log(
      `File too large (${(file.size / 1024 / 1024).toFixed(1)}MB), compressing...`,
    );
    const compressedBlob = await compressImage(
      file,
      MAX_DIMENSION,
      MAX_FILE_SIZE,
    );
    ext = "jpg";
    uploadFile = new File(
      [compressedBlob],
      `${datePrefix}_${baseName}.${ext}`,
      {
        type: "image/jpeg",
      },
    );
    console.log(
      `Compressed to ${(uploadFile.size / 1024 / 1024).toFixed(1)}MB`,
    );
  }

  const fileName = `${datePrefix}_${baseName}.${ext}`;
  const imagesRef = ref(storage, "images/" + fileName);
  uploadBytes(imagesRef, uploadFile).then((snapshot) => {
    console.log(`Uploaded: ${fileName}`);
  });
};

function getBase64Image(img) {
  // Create an empty canvas element
  var canvas = document.createElement("canvas");
  canvas.width = img.width;
  canvas.height = img.height;

  // Copy the image contents to the canvas
  var ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0);

  // Get the data-URL formatted image
  // Firefox supports PNG and JPEG. You could check img.src to
  // guess the original format, but be aware the using "image/jpg"
  // will re-encode the image.
  var dataURL = canvas.toDataURL("image/png");

  return dataURL.replace(/^data:image\/(png|jpg);base64,/, "");
}

export const dataURLtoFile = (dataURL, filename) => {
  const arr = dataURL.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  return srcToFile(dataURL, filename, mime);
  const bstr = Buffer.from(arr[1], "base64");
  // const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);

  while (n--) u8arr[n] = bstr.charCodeAt(n);

  return new File([u8arr], filename, { type: mime });
};

function srcToFile(src, fileName, mimeType) {
  return fetch(src)
    .then(function (res) {
      return res.arrayBuffer();
    })
    .then(function (buf) {
      return new File([buf], fileName, { type: mimeType });
    });
}

export const dataURLtoUint8Array = (dataurl) => {
  console.log(dataurl);
  const arr = dataurl.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = Buffer.from(arr[1], "base64");
  let n = bstr.length;
  console.log(new Uint8Array(n));
  return new Uint8Array(n);
};
